<template lang="pug">
  #new-class.width-100
    .row.m-bottom-3
      h2.title-medium.blue.m-top-05.m-right-1 {{ `${innerI18n.t("sidebar.class")} ${$route.params.classId}` }} -
      krea-text-input.m-bottom-5.item-1(
        programTitle size='medium'
        name="name" edit
        :value='activeResourceClass.name'
        :updateMethod='editClassField'
        :placeholder='innerI18n.t("krea.resource.newClass.namePlaceholder")'
      )
    .features-grid.settings.width-100.m-bottom-2(v-if='!isStudentClass')
      v-popover.column(
        placement='top-start'
        :delay='{show: 100, hide: 600}'
        trigger='hover click'
        popoverClass='krea-actions-popover'
        :container='false'
      )
        .width-100#organizationType
          h3.title-small.m4-bottom-2 {{ innerI18n.t('teacher.organization') }}
          krea-k-select.width-100(
            v-if='organizationEdition'
            :value='activeResourceClass.organizationType'
            :options='organizationOptions'
            @selectOption='editClassSelect'
            name="organizationType" noActions
            :placeholder='innerI18n.t("krea.resource.newClass.organizationPlaceholder")'
          )
          .row.middle.m-top-1.width-100(v-else)
            simple-svg.black-con.m-right-1(:filepath='classOrganization.icon' width='18px' height='18px')
            h2.text-normal {{ classOrganization.text }}
        template(slot='popover')
          actions(@edit='toggleOrganizationEdition' placement='start' edit :info='organizationInfo')
      v-popover.column(
        placement='top-start'
        :delay='{show: 100, hide: 600}'
        trigger='hover click'
        popoverClass='krea-actions-popover'
        :container='false'
      )
        .width-100#classLayout
          h3.title-small.m4-bottom-2 {{ innerI18n.t('teacher.classDistribution') }}
          krea-k-select.feature.m-bottom-2(
            v-if='layoutEdition'
            :value='activeResourceClass.classLayout'
            :options='classPlansOptions'
            @selectOption='editClassSelect'
            name="classLayout" noActions
            :placeholder='innerI18n.t("krea.resource.newClass.classLayoutPlaceholder")'
          )
          .row.middle.m-top-1(v-else)
            img.class-layout.m-right-2(:src='classLayout.icon' :alt='classLayout.text')
            h2.text-normal {{ classLayout.text }}
        template(slot='popover')
          actions(@edit='toggleLayoutEdition' placement='start' edit :info='classDistributionInfo')
      .column#minutesDuration
        h3.title-small.m4-bottom-2 {{ innerI18n.t('teacher.time') }}
        .row.middle.m-bottom-2.width-100
          simple-svg.black-con.m-right-1(v-if='activeResourceClass.minutesDuration' :filepath='timeIcon' width='18px' height='18px')
          krea-text-input.feature(
            inputType='number'
            name="minutesDuration" edit
            :value='activeResourceClass.minutesDuration'
            :updateMethod='editClassField'
            :info='timeInfo'
            :placeholder='innerI18n.t("krea.resource.newClass.timePlaceholder")'
          )
    .features-grid.width-100.m-bottom-2#necessaryMaterials
      .column
        h2.title-medium {{ innerI18n.t("student.necessaryMaterial") }}
      v-popover.column.m-top-1(
        placement='top-start'
        :delay='{show: 100, hide: 600}'
        trigger='hover'
        popoverClass='krea-actions-popover'
        :container='false'
      )
        .width-100
          h3.title-small {{ innerI18n.t('student.devices') }}
          tag-material-selector(
            v-if='electronicMaterialsEdition'
            name='electronicMaterial'
            :placeholder='innerI18n.t("krea.resource.newClass.electronicMaterialPlaceholder")'
            :tags='electronicMaterials'
            @addTag='addMaterial'
            @deleteTag='removeMaterial'
            :maxTags='30'
            :materialType='classMaterialsTypes.electronic'
            :necessaryMaterialType='isStudentClass ? classNecessaryMaterialsTypes.student : classNecessaryMaterialsTypes.teacher'
          )
          .row.middle.m-top-1(v-else)
            simple-svg.m-right-1(:filepath='devicesIcon' width='18px' height='18px' alt='online material')
            span.text-normal {{ electronicMaterialsText }}
        template(slot='popover')
          actions(
            @edit='toggleElectronicMaterialsEdition' placement='start' edit
            :info='!isStudentClass ? electronicMaterialsInfoTeacher : electronicMaterialsInfoStudent'
          )
      v-popover.column.m-top-1(
        placement='top-start'
        :delay='{show: 100, hide: 600}'
        trigger='hover'
        popoverClass='krea-actions-popover'
        :container='false'
      )
        .width-100
          h3.title-small {{ innerI18n.t('student.materials') }}
          tag-material-selector(
            v-if='physicalMaterialsEdition'
            :placeholder='innerI18n.t("krea.resource.newClass.physicalMaterialPlaceholder")'
            name='physcalMaterial'
            :tags='physicMaterials'
            @addTag='addMaterial'
            @deleteTag='removeMaterial'
            :maxTags='30'
            :materialType='classMaterialsTypes.physic'
            :necessaryMaterialType='isStudentClass ? classNecessaryMaterialsTypes.student : classNecessaryMaterialsTypes.teacher'
          )
          .row.middle.m-top-1(v-else)
            simple-svg.m-right-1(:filepath='devicesIcon' width='18px' height='18px' alt='online material')
            span.text-normal {{ physicalMaterialsText }}
        template(slot='popover')
          actions(
            @edit='togglePhysicalMaterialsEdition' placement='start' edit
            :info='!isStudentClass ? physicalMaterialsInfoTeacher : physicalMaterialsInfoStudent'
          )
    .start(v-if='!isStudentClass')
      #startSection.column.m-bottom-2
        label.title-medium.m-bottom-1 {{ innerI18n.t("teacher.start") }}
        krea-text-editor.m-left-1(
          edit
          name="startSection"
          :value='activeResourceClass.startSection'
          @input='editClassField'
          placeholderHeight='200px'
          height='400px'
          :info='startInfo'
          strike underline bold orderedList unorderedList removeMarks quote
          heading italic undo redo linkOption removeLink video image
          :placeholder='innerI18n.t("krea.resource.newClass.startPlaceholder")'
        )
      #developmentSection.column.m-bottom-2
        label.title-medium.m-bottom-1 {{ innerI18n.t("teacher.development") }}
        krea-text-editor.m-left-1(
          edit
          name="developmentSection"
          :value='activeResourceClass.developmentSection'
          @input='editClassField'
          placeholderHeight='200px'
          height='400px'
          :info='developmentInfo'
          strike underline bold orderedList unorderedList removeMarks quote
          heading italic undo redo linkOption removeLink video image
          :placeholder='innerI18n.t("krea.resource.newClass.developmentPlaceholder")'
        )
      #closureSection.column.m-bottom-2
        label.title-medium.m-bottom-1 {{ innerI18n.t("teacher.closure") }}
        krea-text-editor.m-left-1(
          edit
          name="closureSection"
          :value='activeResourceClass.closureSection'
          @input='editClassField'
          placeholderHeight='200px'
          height='400px'
          :info='closureInfo'
          strike underline bold orderedList unorderedList removeMarks quote
          heading italic undo redo linkOption removeLink video image
          :placeholder='innerI18n.t("krea.resource.newClass.closurePlaceholder")'
        )
      #valuationSection.column
        label.title-medium.m-bottom-1 {{ innerI18n.t("teacher.valuation") }}
        krea-text-editor.m-left-1(
          edit
          name="valuationSection"
          :value='activeResourceClass.valuationSection'
          @input='editClassField'
          placeholderHeight='200px'
          height='400px'
          :info='valuationInfo'
          strike underline bold orderedList unorderedList removeMarks quote
          heading italic undo redo linkOption removeLink video image
          :placeholder='innerI18n.t("krea.resource.newClass.valuationPlaceholder")'
        )
    #statement.start.m-bottom-2(v-else)
      .column#studentStatement
        label.title-medium.m-bottom-1 {{ innerI18n.t("student.statement") }}
        krea-text-editor.m-left-1(
          placeholderHeight='200px'
          height='400px'
          name="studentStatement"
          :value='activeResourceClass.studentStatement'
          @input='editClassField'
          edit
          :info='statementInfo'
          strike underline bold orderedList unorderedList removeMarks quote
          heading italic undo redo linkOption removeLink video image
          :placeholder='innerI18n.t("krea.resource.newClass.statementPlaceholder")'
        )
    #necessaryDownloadableMaterials.downloadable-content.m-top-2
      v-popover(
        placement='top-start'
        :delay='{show: 100, hide: 600}'
        trigger='hover'
        popoverClass='krea-actions-popover'
        :container='false'
      )
        .width-100
          label.title-medium {{ innerI18n.t("student.onlineContent") }}
          .column.m-top-1.downloadable-materials
            .row.middle.material(v-for='mat in downloadableMaterials' :key='mat.id || mat.temporalId')
              h2.text-normal {{ mat.description }}
              .row.middle.m-left-2
                a(target='_blank' :href='mat.fileURI' rel='norreferer noopener')
                  simple-svg.dark-gray-icon(:filepath='downloadIcon' width='15px' height='15px')
                button(@click='removeMaterial(mat.id || mat.temporalId)')
                  simple-svg.m-left-1.dark-gray-icon(:filepath='trashIcon' width='16px' height='16px')
          label.primary-button.no-border.button-loading.m-top-2(v-if='uploading') {{ innerI18n.t('krea.resource.valuation.uploading') }}
          label.secondary-button.with-icon.m-top-2(v-else)
            input.hidden(type='file' ref='fileInput' @change='uploadMaterial')
            simple-svg.m-right-1(:filepath='uploadIcon' width='18px' height='18px')
            | {{ innerI18n.t("krea.resource.valuation.uploadFile") }}
        template(slot='popover')
          actions(placement='start' :info='!isStudentClass ? downloadableMaterialsInfoTeacher : downloadableMaterialsInfoStudent')
    .row.middle.m-top-2
      router-link.bold.text-normal.blue(:to='switchClassTabLink')
        | {{ innerI18n.t(`krea.resource.newClass.switchClass.${isStudentClass ? "student" : "teacher"}`, { index: $route.params.classId }) }}
      simple-svg.blue-icon.arrow-icon(:filepath='arrowRight' width='18px' height='18px' :class='{student: isStudentClass}')
    button.primary-button.m-top-2.m-left-auto.m-right-auto(@click='createClass')
      | {{ innerI18n.t("krea.resource.newClass.createClass", {classNumber: activeLocalizedResource.classPlans.length + 1}) }}
</template>

<script>
import KreaKSelect from '@/components/Krea/Inputs/KreaKSelect'
import TagMaterialSelector from '@/components/Krea/Inputs/TagMaterialSelector'
import KreaTextInput from '@/components/Krea/Inputs/KreaTextInput'
import KreaTextEditor from '@/components/Krea/Inputs/KreaTextEditor'
import uploadIcon from '@/assets/ic_upload.svg'
import Group from '@/assets/group_layout.svg'
import Circle from '@/assets/circle_layout.svg'
import HalfCircle from '@/assets/half_circle_layout.svg'
import Row from '@/assets/row_layout.svg'
import Actions from '@/components/Krea/Inputs/Actions/Actions'
import arrowRight from '@/assets/ic_chevron-right.svg'
import uniqid from 'uniqid'
import devicesIcon from '@/assets/ic_devices.svg'
import timeIcon from '@/assets/ic_clock.svg'
import Individual from '@/assets/ic_user_one.svg'
import materialsIcon from '@/assets/ic_materials.svg'
import SmallGroups from '@/assets/ic_user_two.svg'
import downloadIcon from '@/assets/ic_download.svg'
import Multiple from '@/assets/ic_user_multiple.svg'
import trashIcon from '@/assets/krea/ic_trash.svg'
import { routes } from '../../../router'
import { mapActions, mapState } from 'vuex'
import { languagesCodesToString } from '../../../constants/languages'
import { classMaterialsTypes, classNecessaryMaterialsTypes, classPlans, lectureOrganization } from '../../../utils/constants'
import { innerI18n } from '../../../main'
import { getBase64, getExtension } from '../../../utils/file'
import { uploadFile } from '../../../services/FileUploadService'
import { isError } from '../../../utils/api'
import kreaResourceRedirection from '@/mixins/kreaResourceRedirection'

export default {
  mixins: [kreaResourceRedirection],
  components: { TagMaterialSelector, KreaKSelect, KreaTextInput, KreaTextEditor, Actions },
  data() {
    return {
      downloadIcon,
      timeIcon,
      innerI18n,
      uploadIcon,
      arrowRight,
      trashIcon,
      devicesIcon,
      materialsIcon,
      classLayoutIcons: {
        group: Group,
        circle: Circle,
        halfCircle: HalfCircle,
        row: Row
      },
      studentOrganization: {
        individual: Individual,
        smallgroups: SmallGroups,
        group: Multiple
      },
      uploading: false,
      classMaterialsTypes,
      classNecessaryMaterialsTypes,
      layoutEdition: true,
      organizationEdition: true,
      electronicMaterialsEdition: true,
      physicalMaterialsEdition: true
    }
  },
  mounted() {
    this.checkFilledFields()
  },
  watch: {
    currentClasId() {
      this.organizationEdition = true
      this.layoutEdition = true
      this.electronicMaterialsEdition = true
      this.physicalMaterialsEdition = true
      this.checkFilledFields()
    },
    'activeResourceClass.organizationType'() {
      if (!this.activeResourceClass.organizationType) {
        this.organizationEdition = true
      }
    },
    'activeResourceClass.classLayout'() {
      if (!this.activeResourceClass.classLayout) {
        this.layoutEdition = true
      }
    }
  },
  computed: {
    ...mapState({
      activeLanguage: state => state.kreaResource.activeLanguage,
      resource: state => state.kreaResource.resource,
      innerLocale: state => state.behavior.innerLocale
    }),
    currentClasId() {
      return this.$route.params.classId
    },
    kreaContentGuide() {
      return process.env[`VUE_APP_KREA_CREATE_CONTENT_GUIDE_${this.innerLocale}`]
    },
    activeLocalizedResource() {
      return this.resource.localizedResources.find(res => languagesCodesToString[res.locale] === this.activeLanguage)
    },
    activeResourceClass() {
      return this.activeLocalizedResource.classPlans.find(resClass => resClass.classNumber === Number(this.$route.params.classId))
    },
    physicMaterials() {
      return this.activeResourceClass.necessaryMaterials.filter(material =>
        (material.materialType === classMaterialsTypes.physic) &&
        (material.necessaryMaterialType === (this.isStudentClass ? classNecessaryMaterialsTypes.student : classNecessaryMaterialsTypes.teacher))
      )
    },
    electronicMaterials() {
      return this.activeResourceClass.necessaryMaterials.filter(material =>
        (material.materialType === classMaterialsTypes.electronic) &&
        (material.necessaryMaterialType === (this.isStudentClass ? classNecessaryMaterialsTypes.student : classNecessaryMaterialsTypes.teacher))
      )
    },
    downloadableMaterials() {
      return this.activeResourceClass.necessaryMaterials.filter(mat =>
        (mat.materialType === classMaterialsTypes.downloadable) &&
        (mat.necessaryMaterialType === (this.isStudentClass ? classNecessaryMaterialsTypes.student : classNecessaryMaterialsTypes.teacher))
      )
    },
    isStudentClass() {
      return this.$route.name === routes.kreaResourceStudentClass
    },
    switchClassTabLink() {
      return this.isStudentClass
        ? { name: routes.kreaResourceTeacherClass, params: { classId: this.$route.params.classId } }
        : { name: routes.kreaResourceStudentClass, params: { classId: this.$route.params.classId } }
    },
    organizationOptions() {
      return lectureOrganization.map(op => ({ ...op, label: innerI18n.t(`teacher.classOrganization.${op.label}`), value: op.id }))
    },
    classPlansOptions() {
      return classPlans.map(op => ({ ...op, label: innerI18n.t(`krea.resource.newClass.classPlans.${op.label}`), value: op.id }))
    },
    classOrganization() {
      const currentOrganization = this.activeResourceClass.organizationType
      const organizationTypeDescription = lectureOrganization.find(org => org.id === currentOrganization).label
      return {
        text: innerI18n.t(`teacher.classOrganization.${organizationTypeDescription.toLowerCase()}`),
        icon: this.studentOrganization[organizationTypeDescription]
      }
    },
    classLayout() {
      const currentClassLayout = this.activeResourceClass.classLayout
      const layout = classPlans.find(plan => plan.id === currentClassLayout).label
      return {
        text: innerI18n.t(`teacher.classPlanLayout.${layout}`),
        icon: this.classLayoutIcons[layout]
      }
    },
    electronicMaterialsText() {
      return this.electronicMaterials.map(mat => mat.description).join(', ')
    },
    physicalMaterialsText() {
      return this.physicMaterials.map(mat => mat.description).join(', ')
    },
    statementInfo() {
      return {
        title: innerI18n.t('krea.resource.newClass.statementInfoTitle'),
        guideLink: { msg: innerI18n.t('krea.educationalContent.details.contentGuideName'), link: this.kreaContentGuide },
        tips: [innerI18n.t('krea.resource.newClass.statementInfo')]
      }
    },
    organizationInfo() {
      return {
        title: innerI18n.t('krea.resource.newClass.organizationInfoTitle'),
        guideLink: { msg: innerI18n.t('krea.educationalContent.details.contentGuideName'), link: this.kreaContentGuide },
        tips: [innerI18n.t('krea.resource.newClass.organizationInfo')]
      }
    },
    classDistributionInfo() {
      return {
        title: innerI18n.t('krea.resource.newClass.classLayoutInfoTitle'),
        guideLink: { msg: innerI18n.t('krea.educationalContent.details.contentGuideName'), link: this.kreaContentGuide },
        tips: [innerI18n.t('krea.resource.newClass.classLayoutInfo')]
      }
    },
    timeInfo() {
      return {
        title: innerI18n.t('krea.resource.newClass.timeInfoTitle'),
        guideLink: { msg: innerI18n.t('krea.educationalContent.details.contentGuideName'), link: this.kreaContentGuide },
        tips: [innerI18n.t('krea.resource.newClass.timeInfo')]
      }
    },
    electronicMaterialsInfoTeacher() {
      return {
        title: innerI18n.t('krea.resource.newClass.electronicMaterialsInfoTitleTeacher'),
        guideLink: { msg: innerI18n.t('krea.educationalContent.details.contentGuideName'), link: this.kreaContentGuide },
        tips: [
          innerI18n.t('krea.resource.newClass.electronicMaterialsInfoTeacher'),
          innerI18n.t('krea.resource.newClass.elecotrnicMaterialsInfoTeacher2')
        ]
      }
    },
    electronicMaterialsInfoStudent() {
      return {
        title: innerI18n.t('krea.resource.newClass.electronicMaterialsInfoTitleStudent'),
        guideLink: { msg: innerI18n.t('krea.educationalContent.details.contentGuideName'), link: this.kreaContentGuide },
        tips: [
          innerI18n.t('krea.resource.newClass.electronicMaterialsInfoStudent'),
          innerI18n.t('krea.resource.newClass.electronicMaterialsInfoStudent2')
        ]
      }
    },
    physicalMaterialsInfoTeacher() {
      return {
        title: innerI18n.t('krea.resource.newClass.physicalMaterialsInfoTitleTeacher'),
        guideLink: { msg: innerI18n.t('krea.educationalContent.details.contentGuideName'), link: this.kreaContentGuide },
        tips: [
          innerI18n.t('krea.resource.newClass.physicalMaterialsInfoTeacher'),
          innerI18n.t('krea.resource.newClass.physicalMaterialsInfoTeacher2')
        ]
      }
    },
    physicalMaterialsInfoStudent() {
      return {
        title: innerI18n.t('krea.resource.newClass.physicalMaterialsInfoTitleStudent'),
        guideLink: { msg: innerI18n.t('krea.educationalContent.details.contentGuideName'), link: this.kreaContentGuide },
        tips: [
          innerI18n.t('krea.resource.newClass.physicalMaterialsInfoStudent'),
          innerI18n.t('krea.resource.newClass.physicalMaterialsInfoStudent2')
        ]
      }
    },
    startInfo() {
      return {
        title: innerI18n.t('krea.resource.newClass.startInfoTitle'),
        guideLink: { msg: innerI18n.t('krea.educationalContent.details.contentGuideName'), link: this.kreaContentGuide },
        tips: [innerI18n.t('krea.resource.newClass.startInfo')]
      }
    },
    developmentInfo() {
      return {
        title: innerI18n.t('krea.resource.newClass.developmentInfoTitle'),
        guideLink: { msg: innerI18n.t('krea.educationalContent.details.contentGuideName'), link: this.kreaContentGuide },
        tips: [innerI18n.t('krea.resource.newClass.developmentInfo')]
      }
    },
    closureInfo() {
      return {
        title: innerI18n.t('krea.resource.newClass.closureInfoTitle'),
        guideLink: { msg: innerI18n.t('krea.educationalContent.details.contentGuideName'), link: this.kreaContentGuide },
        tips: [innerI18n.t('krea.resource.newClass.closureInfo')]
      }
    },
    valuationInfo() {
      return {
        title: innerI18n.t('krea.resource.newClass.valuationInfoTitle'),
        guideLink: { msg: innerI18n.t('krea.educationalContent.details.contentGuideName'), link: this.kreaContentGuide },
        tips: [innerI18n.t('krea.resource.newClass.valuationInfo')]
      }
    },
    downloadableMaterialsInfoTeacher() {
      return {
        title: innerI18n.t('krea.resource.newClass.downloadableMaterialsInfoTitleTeacher'),
        guideLink: { msg: innerI18n.t('krea.educationalContent.details.contentGuideName'), link: this.kreaContentGuide },
        tips: [
          innerI18n.t('krea.resource.newClass.downloadableMaterialsInfo1Teacher'),
          innerI18n.t('krea.resource.newClass.downloadableMaterialsInfo2Teacher'),
          innerI18n.t('krea.resource.newClass.downloadableMaterialsInfo3Teacher')
        ]
      }
    },
    downloadableMaterialsInfoStudent() {
      return {
        title: innerI18n.t('krea.resource.newClass.downloadableMaterialsInfoTitleStudent'),
        guideLink: { msg: innerI18n.t('krea.educationalContent.details.contentGuideName'), link: this.kreaContentGuide },
        tips: [
          innerI18n.t('krea.resource.newClass.downloadableMaterialsInfo1Student'),
          innerI18n.t('krea.resource.newClass.downloadableMaterialsInfo2Student'),
          innerI18n.t('krea.resource.newClass.downloadableMaterialsInfo3Student')
        ]
      }
    }
  },
  methods: {
    ...mapActions([
      'editKreaResourceClassField',
      'addKreaResourceClassMaterial',
      'removeKreaResourceClassMaterial',
      'addKreaResourceClass'
    ]),
    checkFilledFields() {
      if (this.activeResourceClass.organizationType) {
        this.organizationEdition = false
      }
      if (this.activeResourceClass.classLayout) {
        this.layoutEdition = false
      }
      if (this.electronicMaterials.length) {
        this.electronicMaterialsEdition = false
      }
      if (this.physicMaterials.length) {
        this.physicalMaterialsEdition = false
      }
    },
    toggleLayoutEdition() {
      this.layoutEdition = !this.layoutEdition
    },
    toggleOrganizationEdition() {
      this.organizationEdition = !this.organizationEdition
    },
    toggleElectronicMaterialsEdition() {
      this.electronicMaterialsEdition = !this.electronicMaterialsEdition
    },
    togglePhysicalMaterialsEdition() {
      this.physicalMaterialsEdition = !this.physicalMaterialsEdition
    },
    createClass() {
      this.addKreaResourceClass(this.activeLanguage)
      this.$router.push({ name: routes.kreaResourceTeacherClass, params: { classId: this.activeLocalizedResource.classPlans.length } })
    },
    editClassField(value, field) {
      this.editKreaResourceClassField({ value, field, locale: this.activeLanguage, classNumber: Number(this.$route.params.classId) })
    },
    editClassSelect(field, value) {
      this.editKreaResourceClassField({ value, field, locale: this.activeLanguage, classNumber: Number(this.$route.params.classId) })
      if (field === 'organizationType') {
        this.toggleOrganizationEdition()
      }
      if (field === 'classLayout') {
        this.toggleLayoutEdition()
      }
    },
    addMaterial(newMaterial) {
      this.addKreaResourceClassMaterial({ newMaterial, locale: this.activeLanguage, classNumber: Number(this.$route.params.classId) })
    },
    removeMaterial(materialId) {
      this.removeKreaResourceClassMaterial({ materialId, locale: this.activeLanguage, classNumber: Number(this.$route.params.classId) })
    },
    async uploadMaterial(evt) {
      const file = evt.target.files[0]
      const fileExtension = getExtension(file.name)
      const fileSizeMb = (file.size / (1024 * 1024).toFixed(2))
      if (fileSizeMb < 10) {
        this.uploading = true
        const content = await getBase64(file)
        const response = await uploadFile({ content, extension: fileExtension })
        const success = !isError(response.status)
        if (success) {
          this.fileUrl = response.data
          this.addMaterial({
            description: file.name,
            temporalId: uniqid(),
            necessaryMaterialType: this.isStudentClass ? classNecessaryMaterialsTypes.student : classNecessaryMaterialsTypes.teacher,
            materialType: classMaterialsTypes.downloadable,
            fileURI: response.data
          })
        }
        this.uploading = false
        this.$refs.fileInput.value = null
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'src/scss/variables/colors';

.secondary-button{
  cursor: pointer;
}

.class-layout {
  width: 100%;
  max-width: 100px;
}

.features-grid{
  display: grid;
  width: 100%;
  column-gap: 20px;
  grid-template-columns: repeat(3, 1fr);
  &.settings{
    .column{
      min-height: 140px;
    }
  }
}

.downloadable-materials{
  &>*:not(:last-child){
    margin-bottom: 5px;
  }
}

.material{
  display: inline-flex;
  border-radius: 5px;
  border: none;
  margin: 5px;
  padding: 5px;
}

.features{
  &>:not(:last-child){
    margin-right: 25px;
  }
}

.hidden{
  display: none;
}

.class-title{
  display: flex;
  justify-content: flex-start;
  align-items: center;
  &::after {
    border-top: 1px solid $light-gray;
    content: '';
    display: inline-block;
    flex-grow: 1;
    margin-left: 36px;
  }
}

.arrow-icon{
  margin-top: 4px;
  margin-left: 5px;
  &.student{
    order: -1;
    margin-right: 5px;
    margin-left: 0;
    transform: rotate(180deg);
  }
}

@keyframes loading-bar {
  0% { background: linear-gradient(to right, $green 0%, $gray 0%); }
  25% { background: linear-gradient(to right, $green 50%, $gray 50%); }
  50% { background: linear-gradient(to right, $green 75%, $gray 75%); }
  100% { background: linear-gradient(to right, $green 90%, $gray 90%); }
}

.button-loading {
  background-color: $gray;
  background: linear-gradient(to right, $green 90%, $gray 90%);
  animation: loading-bar 5s;
  border: none;
}
</style>
